import React from 'react';
import { connect } from 'react-redux';

import BucketBasicSettings from './BucketBasicSettings';
import Error from '../../components/Error';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import * as bucketConstants from '../../constants/buckets';
import * as bucketSettingsSelectors from '../../selectors/bucketSettingsSelectors';
import isAuthorizedCurrentBucket from '../../hoc/CurrentBucketAuthorization';

class BucketSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    onClose = () => {
        this.setState({ open: false });
        this.props.onReset();
    };

    componentDidUpdate({ loading: wasLoading }) {
        const { loading, error } = this.props;
        if (wasLoading && !loading && !error) {
            this.onClose();
        }
    }

    render() {
        const { onSubmit, loading, isFormValid, error } = this.props;
        const { open } = this.state;
        return (
            <React.Fragment>
                <Dialog open={open} onClose={this.onClose}>
                    <DialogTitle>Settings</DialogTitle>
                    <DialogContent>
                        <BucketBasicSettings />
                        <Error>{error}</Error>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onClose}>CANCEL</Button>
                        <Button
                            onClick={onSubmit}
                            variant="contained"
                            color="primary"
                            disabled={loading || !isFormValid}
                        >
                            {loading ? 'UPDATING' : 'UPDATE'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: bucketSettingsSelectors.getIsLoading(state),
        isFormValid: bucketSettingsSelectors.getIsFormValid(state),
        error: bucketSettingsSelectors.getError(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onSubmit: () => {
        dispatch({
            type: bucketConstants.UPDATE_BUCKET_SETTINGS_REQUEST,
        });
    },
    onReset: () => {
        dispatch({
            type: bucketConstants.RESET_BUCKET_SETTINGS,
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(isAuthorizedCurrentBucket(BucketSettings, true));



// WEBPACK FOOTER //
// ./src/containers/bucketSettings/BucketSettings.js